const usersReducers = {
  admin: 'Administrador',
  analyst: 'Analista de Documentação',
  contractor: 'Empresa terceira'
};

export default usersReducers;
